import { useContext } from 'react';

import {
  CurrentAssetContext,
  type CurrentAssetContextValue,
} from '@/components/current-asset-provider';

export function useCurrentAsset(): CurrentAssetContextValue {
  const context = useContext(CurrentAssetContext);
  if (!context) {
    throw new Error(
      'useCurrentAsset must be used within a CurrentAssetProvider',
    );
  }

  return context;
}
